import { handleAction } from '@gef-ui/utils/fsaActions';
import mergeRight from "ramda/es/mergeRight";
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { formStateActions } from '../../constants';
import { composeAction } from '../../utils';
export default memoizeWithIdentity((formName)=>handleAction(composeAction(formName, formStateActions.UPDATE_FORM_STATE), {
        next (state, { payload }) {
            return mergeRight(state, payload);
        }
    }, {
        pristine: true
    }));
